// eslint-disable-next-line no-restricted-imports
import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { MediaType } from '../MediaType';
import { fetchJSON } from '../fetchJSON';

/**
 * This query is only used for checking unlicensed permissions.
 * Refer to other GraphQL queries if checking other space properties or permissions.
 *
 * The unlicensed permission object is the object with an undefined subject
 * in the `permissions` array in `results` in the response.
 */
export const experimentalUnlicensedPermission: ExperimentalQueries['experimentalUnlicensedPermission'] =
	async (_, { spaceKey }, { network }) =>
		fetchJSON(network, `/wiki/rest/api/space?spaceKey=${spaceKey}&expand=permissions`, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		}).then(
			(payload) => {
				const unlicensedAccessPerm = (payload.results[0]?.permissions || []).find(
					(perm: any) =>
						!perm.subjects &&
						perm.operation.operation === 'read' &&
						perm.operation.targetType === 'space',
				);
				return {
					unlicensedPermissionId: unlicensedAccessPerm?.id,
				};
			},
			() => ({
				unlicensedPermissionId: undefined,
			}),
		);
